import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea150150"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "primary__color__bg"
}
const _hoisted_2 = { class: "home-container" }
const _hoisted_3 = { class: "speaker-name mt-1" }
const _hoisted_4 = { class: "speaker-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_row = _resolveComponent("el-row")!

  return ($setup.speakers.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_row, {
            gutter: 20,
            justify: "center",
            class: "justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { class: "title-speaker primary__color__text" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("speakers.main")), 1)
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.speakers, (speaker, index) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  xs: 24,
                  sm: 24,
                  md: 12,
                  lg: 6,
                  xl: 3,
                  key: index,
                  class: "my-1 text-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_avatar, {
                        fit: "fill",
                        class: "speaker-photo",
                        size: 180,
                        src: 
                speaker.picture == ''
                  ? require('@/assets/no_profile_image.png')
                  : speaker.picture
              
                      }, null, 8, ["src"])
                    ]),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(speaker.speakerName), 1),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(speaker.title), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}